module.exports = __webpack_public_path__ + "static/media/IconWarningTestByCodeTesting.e225f3e2.svg";